import api from '../../../../api/client'

function normalizePaginatedResponse(data) {
  const rows = Array.isArray(data?.data) ? data.data : []
  const pagination = data?.pagination || {}
  return {
    rows,
    count: Number(pagination.count || rows.length),
    limit: Number(pagination.limit || rows.length || 0),
    offset: Number(pagination.offset || 0),
    totalCount: Number(pagination.total_count || 0),
  }
}

export async function listTicketInflow(params = {}) {
  const { data } = await api.get('/ticket-sync/tickets', {
    params: {
      limit: 10,
      offset: 0,
      ...params,
    },
  })
  return normalizePaginatedResponse(data)
}

/** Fetch enriched sync logs (joined with Users / Tasks / Jobs). */
export async function listSyncLogs(params = {}) {
  const { data } = await api.get('/ticket-sync/logs', {
    params: {
      limit: 10,
      offset: 0,
      ...params,
    },
  })
  return normalizePaginatedResponse(data)
}

/** Retry a FAILED or SKIPPED TicketSync log entry by id. */
export async function retryTicketSyncLog(syncId) {
  const { data } = await api.post(`/ticket-sync/logs/${syncId}/retry`)
  return data
}

/** Retry all FAILED TicketSync log entries. */
export async function retryAllFailedSyncs() {
  const { data } = await api.post('/ticket-sync/logs/retry-failed')
  return data
}

export async function getTicketSyncAnalytics() {
  const { data } = await api.get('/ticket-sync/analytics')
  return data?.data || {
    tickets_received: 0,
    tasks_created: 0,
    sync_failures: 0,
    total_syncs: 0,
    sync_success_rate: 0,
    avg_response_time_ms: 0,
  }
}

export async function triggerManualTicketSync() {
  const { data } = await api.post('/ticket-sync/trigger')
  return data
}

export async function listTicketAssigneeOptions(params = {}) {
  const { data } = await api.get('/options/users', {
    params: {
      page: 1,
      page_size: 200,
      ...params,
    },
  })
  return Array.isArray(data) ? data : []
}
